import { c as _c } from "react/compiler-runtime";
import { Box, List, ListItemButton, ListItemText } from '@mui/material';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import Link from 'next/link';
import { use } from 'react';
import GlobalContext from '@/layout/Providers/GlobalContext';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
const DrawerContent = () => {
  const $ = _c(16);
  const {
    navItems,
    user
  } = use(GlobalContext);
  const router = useRouter();
  const {
    t
  } = useTranslation();
  let t0;
  if ($[0] !== navItems || $[1] !== router || $[2] !== t) {
    let t1;
    if ($[4] !== router || $[5] !== t) {
      t1 = item => <Link key={item.path} href={item.path}><ListItemButton sx={styles} selected={router.pathname.split("/[id]")[0] === item.path}><ListItemText primary={t(`styra.menu.${item.title}`, {
            defaultValue: item.title
          })} /></ListItemButton></Link>;
      $[4] = router;
      $[5] = t;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    t0 = navItems.map(t1);
    $[0] = navItems;
    $[1] = router;
    $[2] = t;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const renderItems = t0;
  let t1;
  if ($[7] !== t || $[8] !== user?.user_language) {
    t1 = () => {
      const nspUrls = {
        en: "https://nsp.nemlia.com/",
        da: "https://nsp.nemlia.com/da/forside/",
        de: "https://nsp.nemlia.com/de/home/"
      };
      const href = nspUrls[user?.user_language] || "https://nsp.nemlia.com/";
      return <ListItemButton sx={styles} component="a" href={href} target="_blank" rel="noopener noreferrer"><OpenInNewRoundedIcon color="primary" fontSize="small" sx={{
          mr: 1,
          ml: -0.5
        }} /><ListItemText primary={t("styra.general.documentation")} /></ListItemButton>;
    };
    $[7] = t;
    $[8] = user?.user_language;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const renderNspItem = t1;
  let t2;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      "& .simplebar-content": {
        display: "flex",
        flexDirection: "column"
      }
    };
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== renderNspItem) {
    t3 = renderNspItem();
    $[11] = renderNspItem;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== renderItems || $[14] !== t3) {
    t4 = <Box sx={t2}><List>{renderItems}{t3}</List></Box>;
    $[13] = renderItems;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};
export default DrawerContent;
const styles = {
  px: 3.5,
  '&:hover': {
    color: 'primary.main',
    backgroundColor: 'primary.10'
  },
  '&.Mui-selected': {
    color: 'primary.main',
    backgroundColor: 'primary.10',
    '&::before': {
      content: '""',
      position: 'absolute',
      height: '100%',
      width: 2,
      backgroundColor: 'primary.main',
      top: 0,
      right: 0
    }
  }
};